module.exports = __webpack_public_path__ + "71a07ec4e2ada303c2f2dafaebb6bb77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-penguin-helpful.png
// module id = 2041
// module chunks = 4